import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { TranslocoModule } from '@jsverse/transloco';
import { OrderPreparationDestinationInputComponent } from './components/order-preparation-destination-input/order-preparation-destination-input.component';



@NgModule({
  declarations: [
    OrderPreparationDestinationInputComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslocoModule,
    CommonModule
  ],
  exports: [
    OrderPreparationDestinationInputComponent
  ]
})
export class TableServiceSharedModule { }
